(function() {
    const style = document.createElement('style');
    style.innerHTML = `
        .kite-wrapper {
            position: fixed;
            bottom: -150px; 
            z-index: 99999;
            pointer-events: none;
            will-change: transform;
        }
        .kite-string {
            stroke: #777777; 
            stroke-width: 1.5; 
            fill: none;
        }
        @keyframes kiteFly {
            0% { transform: translate(0, 0) rotate(0deg); opacity: 0; }
            5% { opacity: 1; }
            25% { transform: translate(25px, -35vh) rotate(5deg); }
            50% { transform: translate(-25px, -70vh) rotate(-5deg); }
            75% { transform: translate(15px, -100vh) rotate(3deg); }
            100% { transform: translate(0, -145vh) rotate(0deg); opacity: 0; }
        }
    `;
    document.head.appendChild(style);

    const colors = ['#FF5733', '#33FF57', '#3357FF', '#F333FF', '#FFD700', '#00FFFF', '#FF1493'];

    function createKite() {
        const wrapper = document.createElement('div');
        wrapper.className = 'kite-wrapper';
        const size = Math.floor(Math.random() * 10) + 35; 
        const color = colors[Math.floor(Math.random() * colors.length)];
        
        wrapper.innerHTML = `
            <svg width="${size}" height="250" viewBox="0 0 100 250">
                <path d="M50 100 Q65 160 50 240" class="kite-string" />
                <path d="M50 0 L100 50 L50 100 L0 50 Z" fill="${color}" />
                <path d="M50 0 L50 100 M0 50 L100 50" stroke="rgba(255,255,255,0.4)" stroke-width="1.5" />
                <path d="M42 100 L58 100 L50 115 Z" fill="${color}" />
            </svg>
        `;
        wrapper.style.left = Math.random() * 92 + 'vw';
        const duration = Math.random() * 3 + 7; 
        wrapper.style.animation = `kiteFly ${duration}s ease-in-out forwards`;
        document.body.appendChild(wrapper);
        setTimeout(() => wrapper.remove(), duration * 1000);
    }

    let kiteInterval;

    // Start 1 second after script execution
    setTimeout(() => {
        // First wave
        for(let i=0; i<6; i++) {
            setTimeout(createKite, i * 150);
        }
        // Start continuous loop
        kiteInterval = setInterval(createKite, 700); 

        // STOP generating new kites after 7 seconds
        setTimeout(() => {
            clearInterval(kiteInterval);
        }, 7000); // 7000ms = 7 seconds
        
    }, 1000);
})();